import { Injectable } from '@angular/core';
import { PrecallQualityResult } from '../../models/app/precall/precall-quality-result';
import { BaseStore } from './base.store';

@Injectable({
  providedIn: 'root',
})
export class QualityTestStore extends BaseStore<PrecallQualityResult> {}
